import React, { createRef, RefObject } from 'react';
import {
  StickyBannerPropsBasic,
  stickyVariant
} from '@ecs/tng-common/components/sticky-banner/Banner';
import StickyBanner from '@ecs/tng-common/components/sticky-banner/StickyBanner';
import {
  returnCTAcomponentsData,
  IConfCTAValues,
  DefaultCTAComponentProps,
  ifCRMcampaignIsSet,
  ifCustomCTARestriction
} from '../helpers/cta-components';

// if datOp is not set default SLD value will be set
type StickyBannerProps = DefaultCTAComponentProps & {
  toHideCloseIcon?: boolean;
  variant?: stickyVariant;
  className?: string;
};

interface IBannerProps extends StickyBannerPropsBasic {
  dataLinkAttr: string;
}
type StickyBannerState = {
  bannerProps: IBannerProps | null;
  refElement: RefObject<HTMLElement> | undefined;
};
export default class StickyBannerDynamic extends React.Component<
  StickyBannerProps,
  StickyBannerState
> {
  defaultOp = 'SLD';

  placement = 'slid';

  ctaData: IConfCTAValues | null = ifCustomCTARestriction(this.props.ctaCustom)
    ? null
    : returnCTAcomponentsData({
        customCta: this.props.ctaCustom,
        category: this.props.category,
        articleId: this.props.articleId,
        categoryId: this.props.categoryId,
        placement: this.placement
      });

  constructor(props: StickyBannerProps) {
    super(props);
    this.state = {
      bannerProps: null,
      refElement: createRef()
    };
  }

  componentDidMount() {
    // do not render the component if the initial ctaData is null because it means that the component should not be shown, customCta value restricts it
    if (!ifCustomCTARestriction(this.props.ctaCustom) && typeof window !== 'undefined') {
      // to show the banner only after the header is no longer visible
      const element = document.getElementById('header');
      if (element) {
        this.setState({ refElement: { current: element } });
      }

      const urlParams = new URLSearchParams(window?.location?.search);
      const pc = urlParams.get('pc');
      const ty = urlParams.get('ty');
      if (ifCRMcampaignIsSet(pc, ty)) {
        const stickyCtaData: IConfCTAValues = returnCTAcomponentsData({
          customCta: this.props.ctaCustom,
          pc: pc,
          ty: ty,
          cc: urlParams.get('cc'),
          mkid: urlParams.get('mkid'),
          category: this.props.category,
          articleId: this.props.articleId,
          categoryId: this.props.categoryId,
          placement: this.placement
        });
        this.setState(
          {
            bannerProps: {
              btnLink: stickyCtaData.btnLink,
              heading: stickyCtaData.stickyHeading,
              dataLinkAttr: stickyCtaData.dataLinkAttr,
              btnCopy: stickyCtaData.stickyBtnCopy,
              subCopy: stickyCtaData.stickySubCopy || '',
              dataOp: stickyCtaData.dataOp ?? this.defaultOp
            }
          },
          () => {
            if (this.state.bannerProps?.dataOp && window.opAppend) {
              window.opAppend();
            }
          }
        );
      } else if (this.ctaData) {
        this.setState(
          {
            bannerProps: {
              btnLink: this.ctaData.btnLink,
              heading: this.ctaData.stickyHeading,
              dataLinkAttr: this.ctaData.dataLinkAttr,
              btnCopy: this.ctaData.stickyBtnCopy,
              subCopy: this.ctaData.stickySubCopy || '',
              dataOp: this.ctaData.dataOp ?? this.defaultOp
            }
          },
          () => {
            if (this.state.bannerProps?.dataOp && window.opAppend) {
              window.opAppend();
            }
          }
        );
      }
    }
  }

  render() {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {this.state.bannerProps ? (
          <StickyBanner
            btnCopy={this.state.bannerProps.btnCopy}
            btnLink={this.state.bannerProps.btnLink}
            heading={this.state.bannerProps.heading}
            subCopy={this.state.bannerProps.subCopy}
            btnAttributes={{ 'data-link-both': this.state.bannerProps.dataLinkAttr }}
            toHideCloseIcon={this.props.toHideCloseIcon}
            variant={this.props.variant}
            className={this.props.className}
            dataOp={this.state.bannerProps.dataOp}
            refElement={this.state.refElement}
            mainCTAclick={this.props.buttonCTAclick}
          />
        ) : null}
      </>
    );
  }
}
